import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { TeamSection } from "@/components/sections/TeamSection";
import { CTASection } from "@/components/sections/CTASection";
import { SEO } from "@/components/SEO";

const Team = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Team | It's All About Growth"
        description="Meet Laura Echavarría and Juan Pablo Camacho — the founding operating partners who lead every engagement at IAAG."
        path="/team"
      />
      <Header />
      <main className="pt-20">
        <TeamSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Team;
